export enum LS_NAME {
  VISITOR_ID_LS_NAME = 'visitor_id'
}
